import React from 'react';
import QaqcRfiFormCreate from './QaqcRfiFormCreate';

const QaqcRfiFormView: React.FC = () => {
  return <QaqcRfiFormCreate mode="view" />;
};

export default QaqcRfiFormView;
